import { render } from "./QuickStartPopup.vue?vue&type=template&id=33ae49b8&scoped=true"
import script from "./QuickStartPopup.vue?vue&type=script&lang=js"
export * from "./QuickStartPopup.vue?vue&type=script&lang=js"

import "./QuickStartPopup.vue?vue&type=style&index=0&id=33ae49b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ae49b8"]])

export default __exports__